<template>
  <div>
    <el-table
      v-loading="loading"
      class="App-Admin-Table"
      size="medium"
      stripe
      :data="opportunities"
      style="width: 100%"
    >
      <!--  -->
      <el-table-column align="center" label="#ID" width="60">
        <template #default="scope">
          <el-tooltip :content="scope.row._id">
            <i class="el-icon-office-building"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="business" label="Startup" width="180">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.business.name) }}
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="outcome" label="Outcome">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.outcome) }}
        </template>
      </el-table-column>
      <!--  -->
      <el-table-column prop="WOW" label="WOW" width="100">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.wow) }}
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <el-table-column prop="skill" label="Skill" width="200">
        <template #default="scope">
          {{ $filters.capitalize(scope.row.skill[0]) }} /
          {{ $filters.capitalize(scope.row.skill[1]) }}
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!-- Talents -->
      <el-table-column
        align="center"
        prop="talents"
        label="Talents"
        width="100"
      >
        <template #default="scope">
          {{ scope.row.talents }}
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
      <!-- Is Active -->
      <el-table-column align="center" label="Is Active" width="100">
        <template #default="scope">
          <el-switch :model-value="!scope.row.isArchived" size="mini" />
        </template>
      </el-table-column>
      <!--  -->
      <!-- Actions -->
      <el-table-column align="center" label="Actions" width="120">
        <template #default>
          <el-button
            icon="el-icon-more"
            is-borderless
            circle
            plain
            size="small"
          />
        </template>
      </el-table-column>
      <!--  -->
      <!--  -->
    </el-table>
  </div>
</template>

<script lang="ts">
import { Opportunity } from "@/shared";
import { Options, Vue } from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Options({
  components: {},
})
export default class extends Vue {
  @Prop({ type: Object })
  opportunities?: Array<Opportunity>;

  @Prop({ type: Boolean })
  loading?: boolean;
}
</script>

<style lang="scss">
.App-Admin-Table {
  &.el-table .el-table__body .cell {
    font-size: 12px;
  }
}
</style>
